import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isJson } from '@utils/string.utils';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Handle empty JSON responses.
 */
@Injectable()
export class HttpEmptyInterceptor implements HttpInterceptor {
    /**
     * Intercept request and convert it to text response.
     *
     * BUG: https://github.com/angular/angular/issues/18680
     * As of 2018-01-11 it is closed and reported fixed in Angular 5, however people are still reporting it not working.
     *
     * @param {HttpRequest<any>} req
     * @param {HttpHandler} next
     * @return {Observable<HttpEvent<any>>}
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.responseType === 'json') {
            req = req.clone({ responseType: 'text' });

            return next.handle(req).pipe(map(response => {
                if (response instanceof HttpResponse) {
                    const body = isJson(response.body) ? JSON.parse(response.body) : null;
                    response = response.clone<any>({ body });
                }

                return response;
            }));
        }

        if (req.responseType === 'blob') {
            req = req.clone({ responseType: 'text' });

            return next.handle(req).pipe(map(response => {
                if (response instanceof HttpResponse) {
                    const body = isJson(response.body) ? JSON.parse(response.body) : null;
                    response = response.clone<any>({ body });
                }

                return response;
            }));
        }

        return next.handle(req);
    }
}
